import { apiClient, apiGet } from "@/lib/api/client";
import type { PaginatedParams } from "@/lib/api/types";

const BASE = "/reputation";

export const reputationApi = {
  getDashboard: () => apiGet<{ data: Record<string, unknown> }>(`${BASE}/me`),

  getLeaderboard: (period?: string, limit?: number) => {
    const searchParams = new URLSearchParams();
    if (period) searchParams.set("period", period);
    if (limit) searchParams.set("limit", String(limit));
    return apiGet<{ data: Record<string, unknown>[] }>(`${BASE}/leaderboard?${searchParams.toString()}`);
  },

  getHistory: (params?: PaginatedParams) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    return apiGet<{ data: Record<string, unknown>[] }>(`${BASE}/history?${searchParams.toString()}`);
  },
};